import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { AttributeRequirementsString } from './AttributeRequirementsString'
import { AttributeRequirementsBool } from './AttributeRequirementsBool'
import { AttributeRequirementsInteger } from './AttributeRequirementsInteger'
import { AttributeRequirementsDecimal } from './AttributeRequirementsDecimal'
import { AttributeRequirementsDict } from './AttributeRequirementsDict'
import { AttributeRequirementsFile } from './AttributeRequirementsFile'
/**
* Class ProductAttributeRequirementsDto
*  Метаданные атрибута<br>
*/
export class ProductAttributeRequirementsDto extends ActiveModel {

  /**
  * id
  *   */
  @ActiveField(0)
  id: number = 0


/**
  * displayName
  * Отображаемое название<br>
  */
  @ActiveField('')
  displayName: string = ''


/**
  * systemName
  * Системное название <br><br>Уникален, если не null
  */
  @ActiveField(null)
  systemName: null | string = null


/**
  * defaultConfig
  * Настройки атрибута по умолчанию<br>  */
  @ActiveField({
  setter(model: ProductAttributeRequirementsDto, prop: string, value: AttributeRequirementsString | AttributeRequirementsBool | AttributeRequirementsInteger | AttributeRequirementsDecimal | AttributeRequirementsDict | AttributeRequirementsFile, receiver?: ProductAttributeRequirementsDto ) {
      let concreteValue = value
      switch (value.type) {
          case 'String': {
            concreteValue = AttributeRequirementsString.create(value)
            break;
          }
          case 'Bool': {
            concreteValue = AttributeRequirementsBool.create(value)
            break;
          }
          case 'Integer': {
            concreteValue = AttributeRequirementsInteger.create(value)
            break;
          }
          case 'Decimal': {
            concreteValue = AttributeRequirementsDecimal.create(value)
            break;
          }
          case 'Dict': {
            concreteValue = AttributeRequirementsDict.create(value)
            break;
          }
          case 'File': {
            concreteValue = AttributeRequirementsFile.create(value)
            break;
          }
      }

      return Reflect.set(
        model,
        prop,
        concreteValue,
        receiver
      )
    }
  })
  defaultConfig: AttributeRequirementsString | AttributeRequirementsBool | AttributeRequirementsInteger | AttributeRequirementsDecimal | AttributeRequirementsDict | AttributeRequirementsFile | null | undefined = undefined


  /**
  * includeInProductsList
  * Если true, то значения атрибута для продукта включаются в выдачу в списке<br>  */
  @ActiveField(false)
  includeInProductsList: boolean = false


  /**
  * isScalar
  * Если false, значит значение атрибута - это массив из<br>нескольких значений, иначе это одно значение<br>  */
  @ActiveField(false)
  isScalar: boolean = false
}
